// extracted by mini-css-extract-plugin
export default {"container":"cn_g","title":"cn_cX","department":"cn_j3","address":"cn_j0"};